import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';
import { obtenerConexiones, responderConexion } from '../lib/conexiones';
import SidebarEscritorio from '../components/sala/SidebarEscritorio';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', morado:'#534AB7' };

export default function ConexionesPage() {
  const { user, profile, membership } = useAuth();
  const { isMobile, w } = useScreen();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [conexiones, setConexiones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) return;
    obtenerConexiones(user.id).then(({ data }) => {
      setConexiones(data);
      setLoading(false);
    });
  }, [user?.id]);

  const handleResponder = async (id, estado) => {
    await responderConexion(id, estado);
    setConexiones(prev => prev.map(c => c.id === id ? { ...c, estado } : c));
  };

  const pendientesRecibidas = conexiones.filter(c => c.estado === 'pendiente' && c.user_to_id === user?.id);
  const pendientesEnviadas = conexiones.filter(c => c.estado === 'pendiente' && c.user_from_id === user?.id);
  const activas = conexiones.filter(c => c.estado === 'aceptada');

  const getOtro = (c) => c.user_from_id === user?.id ? c.to : c.from;
  const nombre = (p) => p?.business_name || p?.full_name || 'Emprendedor';

  return (
    <div style={{ background:'#0a0a0a', minHeight:'100vh', fontFamily:font, color:'#fff' }}>
      <header style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'11px 16px', borderBottom:'0.5px solid rgba(255,255,255,0.06)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {isMobile && <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background:'none', border:'none', color:'#fff', fontSize:18, cursor:'pointer' }}>☰</button>}
          <span style={{ fontFamily:serif, fontSize:17, background:'linear-gradient(90deg, #5dc1b9, #FDBE02, #eb636b)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text' }}>T&D</span>
          <span style={{ fontSize:11, padding:'2px 8px', borderRadius:999, background:'rgba(93,193,185,0.18)', color:C.turquesa }}>Conexiones</span>
        </div>
      </header>

      <div style={{ display:'flex', minHeight:'calc(100vh - 50px)' }}>
        {w >= 900 && (sidebarOpen || !isMobile) && <SidebarEscritorio membership={membership} currentView="conexiones" />}

        <main style={{ flex:1, padding:isMobile?'16px 12px':'20px 24px', overflowY:'auto', maxWidth:680 }}>
          {loading ? (
            <div style={{ textAlign:'center', padding:'60px 0' }}>
              <div style={{ width:24, height:24, border:'3px solid rgba(255,255,255,0.08)', borderTopColor:C.turquesa, borderRadius:'50%', animation:'tdSpin 0.8s linear infinite', margin:'0 auto' }} />
              <style>{`@keyframes tdSpin{to{transform:rotate(360deg)}}`}</style>
            </div>
          ) : (
            <>
              {/* Solicitudes recibidas */}
              {pendientesRecibidas.length > 0 && (
                <section style={{ marginBottom:32 }}>
                  <p style={{ fontSize:10, color:C.mango, letterSpacing:1.5, textTransform:'uppercase', margin:'0 0 12px' }}>Solicitudes recibidas</p>
                  {pendientesRecibidas.map(c => {
                    const otro = getOtro(c);
                    return (
                      <div key={c.id} style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(253,190,2,0.2)', borderRadius:16, padding:16, marginBottom:10, display:'flex', alignItems:'center', gap:14 }}>
                        {otro?.avatar_url ? (
                          <img src={otro.avatar_url} alt="" style={{ width:44, height:44, borderRadius:'50%', objectFit:'cover' }} />
                        ) : (
                          <div style={{ width:44, height:44, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, fontWeight:600 }}>{nombre(otro)[0]}</div>
                        )}
                        <div style={{ flex:1 }}>
                          <p style={{ margin:0, fontSize:15, fontWeight:500 }}>{nombre(otro)}</p>
                          <p style={{ margin:'2px 0 0', fontSize:11, color:'rgba(255,255,255,0.4)' }}>Quiere conectar contigo</p>
                        </div>
                        <div style={{ display:'flex', gap:6 }}>
                          <button onClick={() => handleResponder(c.id, 'aceptada')} style={{ padding:'8px 16px', background:C.turquesa, border:'none', borderRadius:50, color:'#fff', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>Aceptar</button>
                          <button onClick={() => handleResponder(c.id, 'rechazada')} style={{ padding:'8px 16px', background:'rgba(255,255,255,0.06)', border:'0.5px solid rgba(255,255,255,0.15)', borderRadius:50, color:'rgba(255,255,255,0.5)', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>Rechazar</button>
                        </div>
                      </div>
                    );
                  })}
                </section>
              )}

              {/* Conexiones activas */}
              <section style={{ marginBottom:32 }}>
                <p style={{ fontSize:10, color:C.turquesa, letterSpacing:1.5, textTransform:'uppercase', margin:'0 0 12px' }}>Conexiones activas</p>
                {activas.length === 0 ? (
                  <div style={{ textAlign:'center', padding:'40px 20px' }}>
                    <p style={{ fontSize:32, margin:'0 0 8px' }}>🤝</p>
                    <p style={{ fontSize:14, color:'rgba(255,255,255,0.4)' }}>Aun no tienes conexiones activas. Ve a Matches para encontrar emprendedores afines.</p>
                    <button onClick={() => navigate('/matches')} style={{ marginTop:12, padding:'10px 24px', background:C.turquesa, border:'none', borderRadius:50, color:'#fff', fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>Ver matches →</button>
                  </div>
                ) : activas.map(c => {
                  const otro = getOtro(c);
                  return (
                    <div key={c.id} onClick={() => navigate('/chat/' + c.id)} style={{ background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:16, padding:16, marginBottom:10, display:'flex', alignItems:'center', gap:14, cursor:'pointer', transition:'border-color 0.3s' }}
                      onMouseEnter={e => e.currentTarget.style.borderColor='rgba(93,193,185,0.3)'}
                      onMouseLeave={e => e.currentTarget.style.borderColor='rgba(255,255,255,0.1)'}
                    >
                      {otro?.avatar_url ? (
                        <img src={otro.avatar_url} alt="" style={{ width:44, height:44, borderRadius:'50%', objectFit:'cover' }} />
                      ) : (
                        <div style={{ width:44, height:44, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, fontWeight:600 }}>{nombre(otro)[0]}</div>
                      )}
                      <div style={{ flex:1 }}>
                        <p style={{ margin:0, fontSize:15, fontWeight:500 }}>{nombre(otro)}</p>
                        <p style={{ margin:'2px 0 0', fontSize:11, color:'rgba(255,255,255,0.4)' }}>{otro?.business_type || ''}</p>
                      </div>
                      <span style={{ fontSize:12, color:C.turquesa }}>💬 Abrir chat</span>
                    </div>
                  );
                })}
              </section>

              {/* Solicitudes enviadas */}
              {pendientesEnviadas.length > 0 && (
                <section>
                  <p style={{ fontSize:10, color:'rgba(255,255,255,0.4)', letterSpacing:1.5, textTransform:'uppercase', margin:'0 0 12px' }}>Solicitudes enviadas</p>
                  {pendientesEnviadas.map(c => {
                    const otro = getOtro(c);
                    return (
                      <div key={c.id} style={{ background:'rgba(255,255,255,0.03)', border:'0.5px solid rgba(255,255,255,0.08)', borderRadius:16, padding:16, marginBottom:10, display:'flex', alignItems:'center', gap:14, opacity:0.7 }}>
                        <div style={{ width:44, height:44, borderRadius:'50%', background:'rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>{nombre(otro)[0]}</div>
                        <div style={{ flex:1 }}>
                          <p style={{ margin:0, fontSize:14, color:'rgba(255,255,255,0.7)' }}>{nombre(otro)}</p>
                        </div>
                        <span style={{ fontSize:11, color:C.mango }}>⏳ Pendiente</span>
                      </div>
                    );
                  })}
                </section>
              )}
            </>
          )}
        </main>
      </div>
    </div>
  );
}
